// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\GoogleCalendarListItemResponse

export type GoogleCalendarListItemApiResponse = {
	id: string;
	name: string;
	googleAuthId: number;
};

export type GoogleCalendarListItem = {
	id: string;
	name: string;
	googleAuthId: number;
};

export function hydrateGoogleCalendarListItem(data: GoogleCalendarListItemApiResponse): GoogleCalendarListItem {
	return { ...data };
}